/**
 * Native POI layer mapping and click tolerance for the MapLibre base style.
 */

/**
 * MapTiler style layer IDs that represent clickable points of interest,
 * mapped to an internal POI category.
 */
export const NATIVE_POI_LAYERS: Record<string, string> = {
    "Accommodation":       "HOTEL",
    "Food":                "FOOD",
    "Shopping":            "STORE",
    "Mall":                "MALL",
    "Healthcare":          "HEALTHCARE",
    "Education":           "EDUCATION",
    "Public":              "PUBLIC",
    "Park":                "PARK",
    "Culture":             "CULTURE",
    "Religion":            "RELIGION",
    "Tourism":             "TOURISM",
    "Sport":               "SPORT",
    "Parking special":     "PARKING",
    "Parking":             "PARKING",
    "Airport terminal":    "AIRPORT",
    "Airport labels":      "AIRPORT",
    "Airport gate labels": "AIRPORT",
};

/**
 * Hit radius in pixels around a click to detect a native POI more easily.
 */
export const POI_CLICK_HIT_RADIUS_PX = 8;

/**
 * Build a screen-space bounding box around a point using the configured
 * POI click hit radius.
 */
export function buildPoiQueryBox( point: {
    "x": number;
    "y": number;
} ): [[number, number], [number, number]] {
    return [
        [ point.x - POI_CLICK_HIT_RADIUS_PX, point.y - POI_CLICK_HIT_RADIUS_PX ],
        [ point.x + POI_CLICK_HIT_RADIUS_PX, point.y + POI_CLICK_HIT_RADIUS_PX ],
    ];
}
